import {BaseView} from '../core/view';
import { TrackingUtil } from "../utils/tracking"

let scrollObject = [];

export default BaseView.extend({

    el: '.js-scrollable-main',

    events:{
        'click .js-scrollable-main-arrow-left': 'leftArrowClick',
        'click .js-scrollable-main-arrow-right': 'rightArrowClick',
        'click .js-scrollable-main-bobble': 'throwClickEvent'
    },

    initialize: function () {
        if (this.el) {
            let self = this;
            this.scrollTrick = this.el.querySelector('.js-scrollable-main-scrolltrick');
            scrollObject['padding-width'] = this.isHOS ? 55 : 13;
            this.updateSwipySettings();

            this.scrollTrick.addEventListener('scroll', _.throttle(this.checkScrollPosition.bind(this), 200));

            window.addEventListener('resize', () => {
                if(window.innerWidth < 992){
                    self.updateSwipySettings();
                }
            });

            //need a timer to fix scroll width due to safari bug
            setTimeout(function () {
                self.updateSwipySettings()
            }, 500);

            TrackingUtil.throwGAEvent('Scrollable', this.el.getAttribute('data-ga-action') + "View", '', true);
        }
    },

    leftArrowClick: function(){
        $(this.scrollTrick).animate({scrollLeft: "-=100"}, '200');
    },

    rightArrowClick: function(){
        $(this.scrollTrick).animate({scrollLeft: "+=100"}, '200');
    },

    throwClickEvent: function(e){
        const url = e.currentTarget.getAttribute('data-link');
        const action = this.$el.attr('data-ga-action') + "Click";
        TrackingUtil.throwGAEvent('Scrollable', action, url, false);
    },

    updateScroll: function() {
        scrollObject['scrollcontainer-width'] = this.el.querySelector('.js-scrollable-main-container').getBoundingClientRect().width;
        scrollObject['viewport-width'] = this.el.getBoundingClientRect().width;
        scrollObject['left-limit'] = scrollObject['padding-width'];
        scrollObject['right-limit'] = this.isHOS ? scrollObject['scrollcontainer-width'] - scrollObject['viewport-width'] : scrollObject['scrollcontainer-width']-(scrollObject['padding-width']+scrollObject['viewport-width']);
    },

    updateSwipySettings: function() {
        this.updateScroll();
        this.checkScrollPosition();
    },

    checkScrollPosition: function(){
        this.updateScroll();
        scrollObject['scroll-position'] = this.scrollTrick.scrollLeft;
        let viewportWidth = scrollObject['viewport-width'];
        let containerWidth = scrollObject['scrollcontainer-width'];
        if ( viewportWidth >= containerWidth){
            this.hideRightArrow();
            this.hideLeftArrow();
        }
        else{
            let scrollPos = scrollObject['scroll-position'];
            let leftLim = scrollObject['left-limit'];
            let rightLim = scrollObject['right-limit'];

            if (scrollPos < leftLim){
                this.hideLeftArrow();
            }else{
                this.showLeftArrow();
            }
            if (scrollPos >= rightLim){
                this.hideRightArrow();
            }else{
                this.showRightArrow();
            }
        }
    },

    hideLeftArrow: function(){
        if(document.querySelector('.js-is-new-filters')){
            let event = document.createEvent('Event');
            event.initEvent('expandFiltersButton', true, true);
            this.el.dispatchEvent(event);
            this.updateScroll();
        }
        else{
            this.el.classList.add('scrollable-list--hide-left-arrow');
        }
    },

    hideRightArrow: function(){
        if(!document.querySelector('.js-is-new-filters')){
            this.el.classList.add('scrollable-list--hide-right-arrow');
        }
    },

    showLeftArrow: function(){
        if(document.querySelector('.js-is-new-filters')){
            let event = document.createEvent('Event');
            event.initEvent('collapseFiltersButton', true, true);
            this.el.dispatchEvent(event);
            this.updateScroll();
        }
        else{
            this.el.classList.remove('scrollable-list--hide-left-arrow');
        }
    },

    showRightArrow: function(){
        if(!document.querySelector('.js-is-new-filters')){
            this.el.classList.remove('scrollable-list--hide-right-arrow');
        }
    }

});